<template>
  <div class="body-container order-index-page">
    <van-tabs v-model="active" type="card" color="#236DFF" sticky @change="tabClick" v-if="$tools.isOKTX()">
      <van-tab title="团财险">
        <div class="group-list-tab">
          <groupList></groupList>
        </div>
      </van-tab>
      <van-tab title="人身个险">
        <div class="order-list-tab">
          <orderList></orderList>
        </div>
      </van-tab>
    </van-tabs>
    <van-tabs v-model="active" type="card" color="#236DFF" sticky @change="tabClick" v-else>
      <van-tab title="人身个险">
        <div class="order-list-tab">
          <orderList></orderList>
        </div>
      </van-tab>
      <van-tab title="团财险">
        <div class="group-list-tab">
          <groupList></groupList>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { pageTools, common } from '@/api/mixins';
import orderList from './list';
import groupList from './group/list';

export default {
  name: 'order.order.index',
  mixins: [pageTools, common],
  components: { orderList, groupList },
  data() {
    return {
      active: 0
    };
  },
  mounted() {
    if (!this.checkLogin()) {
      return;
    }
    if (sessionStorage.appOrderTabIndex) {
      this.active = sessionStorage.appOrderTabIndex * 1;
    }
    if (this.$route.query.status == '1' && this.$tools.isOKbao()) {
      this.$tools.setWebTitle('待付款');
    } else if (this.$route.query.type == '1') {
      this.$tools.setWebTitle('我的订单');
    } else {
      this.$tools.setWebTitle('保单管理');
    }
    this.$weixin.hideMenu();
  },
  methods: {
    tabClick(val) {
      sessionStorage.appOrderTabIndex = val;
    }
  }
};
</script>

<style lang="scss" scoped>
.order-index-page {
  /deep/.van-sticky {
    background-color: #fff;
  }

  /deep/.group-order-page,
  /deep/.order-page {
    height: calc(100vh - 110px);
    background-color: #f5f5f5;
  }

  &.show-bottom-nav {
    /deep/.group-order-page,
    /deep/.order-page {
      height: calc(100vh - 220px);
    }
  }

  /deep/.van-tabs {
    border-bottom: unset;
    .van-tabs__nav--card {
      margin: 26px auto;
      // overflow: hidden;
      width: 510px;
      height: 60px;
      border-radius: 10px;
      border-color: unset !important;
      border: unset !important;
      .van-tab {
        border-top: 1px solid #236dff;
        border-bottom: 1px solid #236dff;
        box-sizing: border-box;
        &:last-child {
          border-right: 1px solid #236dff;
          border-radius: 0 2px 2px 0;
        }
        &:first-child {
          border-left: 1px solid #236dff;
          border-radius: 2px 0 0 2px;
        }
      }
      //   :nth-last-child(2) {
      //     border-radius: 2px 0 0 2px;
      //   }
      //   :last-child {
      //     border-radius: 0 2px 2px 0;
      //   }
      .van-tab__text {
        color: #236dff;
        font-size: 30px;
      }

      .van-tab--active {
        background-color: #236dff;
        border: unset;
        border-color: unset;

        overflow: hidden;
        &::before {
          content: '';
          display: inline-block;
          position: absolute;
          left: -4px;
          right: -4px;
          top: -4px;
          bottom: -4px;
          background-color: #236dff;
        }
        .van-tab__text {
          color: #fff;
          font-weight: 400;
          font-size: 30px;
          z-index: 1;
        }
      }
    }
  }
}
</style>
